/**
 * Retrieves the brandCollection from the BR page content.
 * Iterates over the individual brands and parses the data.
 * Returns a parsed BrandPromotion array
 */ function getBrandPromotions(brands) {
    if (!brands || brands.length === 0) {
        return [];
    }
    // Parse individual brand information, filter out nullish entries
    const parsedBrands = brands.map(parseBrandFromCollection).filter((brand)=>Boolean(brand)
    );
    return parsedBrands;
}
/**
 * Get the brand content at the provided $ref from the pageModel
 * returns CmsBrandPromotion data or null if data is missing.
 */ function parseBrandFromCollection(brand) {
    const { promotionLink , promotionLogo , title , clickablePromotionLogo  } = brand !== null && brand !== void 0 ? brand : {};
    // Return null if we don't have the correct data
    if (!title) {
        return null;
    }
    return {
        name: title,
        url: promotionLink === null || promotionLink === void 0 ? void 0 : promotionLink.url,
        logo: promotionLogo === null || promotionLogo === void 0 ? void 0 : promotionLogo.url,
        clickableLogo: clickablePromotionLogo === null || clickablePromotionLogo === void 0 ? void 0 : clickablePromotionLogo.url
    };
}

export { getBrandPromotions };
//# sourceMappingURL=get-brand-promotions.js.map
